module.exports = "https://cdn.realtymogul.com/static/media/icon_diversification.fdd8c3c3.svg";